<template>
    <div class="x_box A4">
        <div class="x_body">
            <ReportHeader/>
            <div class="print-header">
                <h6 class="text-center" style="font-weight: 600;">{{$t('stock_in')}}</h6>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table class="table-print">
                        <tbody>
                            <tr>
                                <td style="width: 100px;">{{ $t('branch_name') }}</td>
                                <td style="width: 15px;">:</td>
                                <td>{{branch.Name}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('receiver') }}</td>
                                <td>:</td>
                                <td>{{employee.KhmerName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table class="table-print" align="right">
                        <tbody>
                            <tr>
                                <td>{{ $t('stock_in_no') }}</td>
                                <td style="width: 15px;">:</td>
                                <td style="min-width: 150px;">{{stockin.Num}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('date')}}</td>
                                <td>:</td>
                                <td>{{$format(stockin.InDateAt, 'DD/MM/YYYY')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('item_code')}}</th>
                                <th>{{$t('item_name')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-center">{{$t('received')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in lines" :key="index">
                                <td>{{index + 1}}</td>
                                <td>{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Description}}</td>
                                <td class="text-center">{{ret.QuantityIn}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ReportHeader from '../../Components/ReportHeader';
    export default {
        components: { ReportHeader },
        data() {
            return {
                company: {},
                stockin: {},
                lines: [],
                branch: {},
                employee: {}
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('stockin/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        var data = res.data.Data;
                        this.stockin = data.StockIn;
                        this.branch = data.Branch;
                        this.employee = data.Employee;
                        this.lines = data.StockInLines;
                    }
                }).finally(function() { loading.hide(); });
            }
        }
    }
</script>